import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Pathology, PathologyResponse } from '../../models/pathology';

@Injectable({
    providedIn: 'root',
})
export class PathologyService {
    #apiUrl = environment.apiUrl;
    #http = inject(HttpClient);
    private _authHeaders = new HttpHeaders({
        Authorization: '',
    });

    fetchPathologies() {
        return this.#http.get<{ data: Pathology[] }>(`${this.#apiUrl}/api/pathology/list`, {
            headers: this._authHeaders
        }).pipe(map(response => response.data));
    }
}
